<!-- Header -->
<div class="tw-pr-2 tw-border-b tw-border-primary/10 tw-flex tw-justify-between tw-items-center">
  <h2 class="!tw-px-5 !tw-py-4 tw-text-primary tw-font-bold tw-text-lg">
    HISTÓRICO DE PRECIOS
  </h2>

  <button mat-icon-button (click)="onClose()" autofocus="false">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="!tw-p-2 !tw-font-[inherit]">
  <!-- Loading State -->
  <div *ngIf="loading" class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="tw-mt-5 tw-text-gray-600">Cargando histórico de precios...</p>
  </div>

  <!-- No Data State -->
  <div *ngIf="!loading && priceHistory.length === 0" class="tw-flex tw-items-center tw-justify-center tw-py-10">
    <p class="tw-text-gray-600 tw-text-base">No hay histórico de precios disponible para este medicamento.</p>
  </div>

  <!-- Table with Data -->
  <div *ngIf="!loading && priceHistory.length > 0">
    <table mat-table [dataSource]="priceHistory" class="!tw-bg-transparent">

      <!-- Fecha Column -->
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none tw-w-28 !tw-rounded-l-lg">Fecha</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-bold tw-text-sm">{{ formatDate(element.Fecha) }}</td>
      </ng-container>

      <!-- Laboratorio Column -->
      <ng-container matColumnDef="laboratorio">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none">Laboratorio</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-normal tw-text-sm">{{ element.LaboratorioName || '-' }}</td>
      </ng-container>

      <!-- Distribuidor Column -->
      <ng-container matColumnDef="distribuidor">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none">Distribuidor</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-normal tw-text-sm">{{ element.DistribuidorName || '-' }}</td>
      </ng-container>

      <!-- PVL Column -->
      <ng-container matColumnDef="pvl">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none tw-w-24">PVL</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-bold tw-text-sm !tw-text-primary">{{ formatCurrency(element.PVL) }}</td>
      </ng-container>

      <!-- Descuento Column -->
      <ng-container matColumnDef="descuento">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none tw-w-24">Descuento</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-normal tw-text-sm">{{ formatPercentage(element.Descuento) }}</td>
      </ng-container>

      <!-- Recargo Column -->
      <ng-container matColumnDef="recargo">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none tw-w-24">Recargo</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-normal tw-text-sm">{{ formatPercentage(element.Recargo) }}</td>
      </ng-container>

      <!-- PVLN Column -->
      <ng-container matColumnDef="pvln">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none tw-w-24">PVLN</th>
        <td mat-cell *matCellDef="let element" class="!tw-border-primary/10 tw-font-bold tw-text-sm !tw-text-primary">{{ formatCurrency(element.PVLN) }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="!tw-text-white !tw-bg-primary !tw-border-none tw-w-20 !tw-rounded-r-lg">Acciones</th>
        <td mat-cell *matCellDef="let element; let i = index" class="!tw-border-primary/10">
          <button
            *ngIf="i !== 0"
            mat-icon-button
            color="primary"
            (click)="onEdit(element); $event.stopPropagation()"
            matTooltip="Editar"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;" class="!tw-h-10 tw-text-xs !tw-bg-transparent"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:!tw-bg-primary/5"></tr>
    </table>
  </div>
</mat-dialog-content>
